import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "新闻", to: "/news" },
      { label: "视频", to: "/video" },
      { label: "百科", to: "/encyclopedia" },
      { label: "综合搜索", to: "/search" },
    ],
  },
  {
    title: "热门专区",
    links: [
      { label: "热门搜索", to: "/hotsearch" },
      { label: "关于我们", to: "/about" },
      { label: "隐私政策", to: "/about" },
      { label: "法律声明", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50">
                百
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">百度一下</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              免费的综合信息搜索与导航平台，聚合新闻、视频、百科等多领域内容，帮助你高效、精准地找到所需信息与资源。
            </p>
            <p className="mt-3 inline-flex rounded-md bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
              演示范围，待接入后端支持
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <p className="font-heading text-sm font-bold text-foreground-950">
                <span>{col.title}</span>
              </p>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 百度一下 · 本站为演示项目，所有内容均为示例数据
          </p>
          <p className="text-xs text-foreground-500">
            友情链接：信息聚合 · 内容导航 · 搜索体验
          </p>
        </div>
      </div>
    </footer>
  );
}